/* eslint-disable no-empty-pattern */
/* eslint-disable react/prop-types */
import { makeStyles } from "@material-ui/core";
import mixpanelTrack from "app/common/MixpanelComponent";
import React from "react";
import ScenarioSummary from "./scenarios-matrix/ScenarioSummary";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    gap: "15px",
    width: "100%",
    height: "100%",
    padding: "15px",
    boxSizing: "border-box",
    fontFamily: "Lato",
    [theme.breakpoints.up(2560)]: { fontSize: "16px" },
    [theme.breakpoints.between(1920, 2560)]: { fontSize: "14.5px" },
    [theme.breakpoints.between(1440, 1920)]: { fontSize: "13px" },
    [theme.breakpoints.between(1280, 1440)]: { fontSize: "12px" },
    [theme.breakpoints.down(1280)]: {
      fontSize: "12px",
      flexDirection: "column",
    },
  },
}));

function SummaryComponent({}) {
  const classes = useStyles();

  React.useEffect(() => {
    /* MIXPANEL TRACKS */
    mixpanelTrack("Summary Scenario visited");
    /* END OF MIXPANEL TRACKS */
  }, []);

  return (
    <>
      <div className={classes.root}>
        <ScenarioSummary />
      </div>
    </>
  );
}

export default SummaryComponent;
